/**
 * Service de classificação de produtos
 */

import { api } from './api';
import { API_ENDPOINTS, Classificacao } from '@types';

export class ClassificacaoService {
  /**
   * Obtém todas as classificações
   */
  async obterClassificacoes(): Promise<Classificacao[]> {
    try {
      const response = await api.get<Classificacao[]>(API_ENDPOINTS.OBTER_CLASSIFICACAO);
      return response;
    } catch (error) {
      console.error('Erro ao obter classificações:', error);
      throw error;
    }
  }

  /**
   * Obtém classificação por código
   */
  async obterPorCodigo(codigo: string): Promise<Classificacao | null> {
    try {
      const classificacoes = await this.obterClassificacoes();
      return classificacoes.find((c) => c.codigo === codigo) || null;
    } catch (error) {
      console.error('Erro ao obter classificação:', error);
      throw error;
    }
  }

  /**
   * Busca classificações por nome
   */
  async buscar(termo: string): Promise<Classificacao[]> {
    try {
      const classificacoes = await this.obterClassificacoes();
      
      if (!termo) return classificacoes;

      const termoLower = termo.toLowerCase();
      
      return classificacoes.filter((c) =>
        c.nome.toLowerCase().includes(termoLower)
      );
    } catch (error) {
      console.error('Erro ao buscar classificações:', error);
      throw error;
    }
  }
}

export const classificacaoService = new ClassificacaoService();